module.exports = __webpack_public_path__ + "static/media/icicles.a023145a.svg";